/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon32Regular = forwardRef('ArrowAUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M6.207 13.957a1 1 0 0 1-1.414-1.414l8.379-8.379a4 4 0 0 1 5.656 0l8.38 8.379a1 1 0 0 1-1.415 1.414l-8.379-8.379A2.003 2.003 0 0 0 17 5.26V28a1 1 0 1 1-2 0V5.26a2.003 2.003 0 0 0-.414.318l-8.379 8.38Z" })));
});
